<template>
 <div
      id="myFullScreen"
     class="desktop-panel"
      style="display: none;"
    >
  <div class="media-wrapper">
      <!-- Toggle button -->
    <!-- → popup icon -->
      <button v-if="activeTab === 'desk'"  class="toggle-overlay-btn" :style="{ left: '10px' ,display:'none'}" @click="openPopup(focusedItem.src)" title="Open in Popup">
        <i class="far fa-external-link-alt"></i>
      </button>
      <button
        class="toggle-overlay-btn"
        :style="{ right: overlayVisible ? '193px' : '10px' ,border:'3px solid #0072C5'}"
        @click="toggleOverlay"
      >
        <span v-if="overlayVisible">⮞</span>
        <span v-else>⮜</span>
      </button>

      <!-- Main focus view -->
      <div class="primary-view">
        <!-- Show avatar for audio calls -->
        <img
          v-if="focusedItem.type === 'audio'"
          :src="focusedItem.avatar"
          class="avatar"
          alt="Audio Avatar"
        />
        <audio
          v-else-if="focusedItem.type === 'audio'"
          :src="focusedItem.src"
          ref="focusedAudio"
          class="focused-audio primary-video"
        ></audio>
        <!-- Webpage view -->
        <iframe
          v-if="['webpage','deskwebpage','panelwebpage'].includes(focusedItem.type)"
          :key="focusedItem.src + reloadKey"
          :src="focusedItem.src"
          :data-clientid="focusedItem.clientId"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allowfullscreen
        ></iframe>
        <!-- Video or stream view -->
        <video
          v-if="focusedItem.type === 'videoFile'  || focusedItem.type === 'Video'"
          :src="focusedItem.src"
          ref="primaryVideo"
          class = "primary-video"
          autoplay
        ></video>
        <video
          v-else-if="focusedItem.type === 'stream' || focusedItem.type === 'screen'"
          :srcObject="focusedItem.stream"
          ref="primaryVideo"
          class = "primary-video"
          autoplay
        ></video>
      </div>
        <!-- full-screen iframe popup -->
      <teleport to="body">
        <div v-if="showPopup" class="iframe-backdrop" @click.self="closePopup">
          <div class="iframe-modal">
            <div style="display: flex;justify-content: left;align-items: left;font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;font-size: 14px;font-weight: 500;line-height: 20px;text-align: center;color: #fff;transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;padding: 6px 16px;line-height: 20px;background-color: rgb(0, 114, 197); color: white; display: flex;">Set Behaviour</div>

            <button class="iframe-close" @click="closePopup">×</button>
            <div class="desk-icon-bar" style="display:'';" v-if="activeTab==='desk'">
                  <div class="entries-grid">
                
                    <!-- Row 1: Roles -->
                    <div class="row roles">
                      <div class="cell">
                       <span class="result-label">Role:</span>
                       <span class="result-value">[{{ focusedItem.role }}]</span>
                      </div>
                    </div>

                    <!-- Row 2: Actions -->
                    <div class="row actions">
                      <div class="cell">
                         <span class="result-label">Action:</span>
                         <span class="result-value">[{{ focusedItem.action }}]</span>
                      </div>
                    </div>

                    <!-- Row 3: Results -->
                    <div class="row results">
                      <span class="result-label">Result:</span>
                      <div
                        v-for="res in focusedItem.result"
                        :key="res"
                        class="cell1"
                      >
                         
                         <span class="result-value" @click = "executeDesk(focusedItem.clientId,focusedItem.nodecomponent,focusedItem.nodeObj,res)">[{{ res }}]</span>
                      
                      </div>
                    </div>
                  </div>
                  <!-- etc… -->
                </div>
            </div>
          </div>
      </teleport>
      <!-- full-screen iframe popup -->
      <teleport to="body">
        <div v-if="showUserPopup" class="iframe-backdrop" @click.self="closeUserPopup">
          <div class="iframe-modal">
            <div style="display: flex;justify-content: left;align-items: left;font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;font-size: 14px;font-weight: 500;line-height: 20px;text-align: center;color: #fff;transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;padding: 6px 16px;line-height: 20px;background-color: rgb(0, 114, 197); color: white; display: flex;">Add Participant</div>

            <button class="iframe-close" @click="closeUserPopup">×</button>
            <div class="desk-icon-bar" style="display:'';" v-if="activeTab==='media'">
                  <div class="entries-grid">
                    
                    <!-- Row 1: Roles -->
                    <div class="row roles">
                      <span class="result-label">&nbsp;&nbsp;</span>
      
                      <div class="cell">
                       <input
                          v-model="newparticipant"
                          type="text"
                          placeholder="Enter Email or Phone"
                          @keyup.enter="submitParticipant"
                        />
                      </div>
                    </div>

                    <div class="row results">
                      <span class="result-label"></span>
                      <div class="cell1">
                         
                         <span class="result-value" @click="submitParticipant">[Invite]</span>
                         <span class="result-value" @click="closeUserPopup">[Cancel]</span>    
                      </div>
                    </div>
                    
                  </div>
                  <!-- etc… -->
                </div>
            </div>
          </div>
    </teleport>
  <!-- Place this AFTER your main wrapper: -->
  <teleport to="body">
    <div id="raise-hand-container" class="raise-hand-container"></div>
  </teleport>
      <!-- Overlay menu -->
      <!--  v-for="(item, i) in mediaItems"-->
    <div class="video-grid-overlay" :class="{ collapsed: !overlayVisible }">
        <!-- Expanded tiles -->
        <div v-if="overlayVisible" class="video-grid-overlay1">
          <!-- Left menu for dynamic streams (ONE container only) -->
            <!-- Tab bar -->
                <div class="overlay-tabs">
                    <button
                      :class="{ active: activeTab === 'media' }"
                      @click="activeTab = 'media'"
                      title="Media"
                    >
                      <i class="far fa-photo-video"></i>
                    </button>
                    <button
                      :class="{ active: activeTab === 'desk' }"
                      @click="activeTab = 'desk'"
                      title="Stages"
                    >
                      <i class="far fa-users-rectangle"></i>
                    </button>
                    <button
                      :class="{ active: activeTab === 'participants' }"
                      @click="activeTab = 'participants'"
                      title="Participants"
                    >
                      <i class="far fa-user-friends"></i>
                    </button>
                    <!-- Panels button -->
                    <button
                      :class="{ active: activeTab === 'panels' }"
                      @click="activeTab = 'panels'"
                      title="Panels"
                    >
                      <i class="far fa-columns"></i>
                    </button>
                  </div>


        <div class="tiles-container" ref="tilesContainer">
              <div v-if="activeTab !== 'participants'">
                <div v-if="activeTab !== 'panels'">
                  <div
                      v-for="(item,i) in activeTab === 'media' ? mediaItems : deskItems"
                      :key=" item.type==='stream'? item.clientId : i "
                      class="video-tile"
                      @click="focusItem(item,i)"
                    >
                    <!-- live streams -->
                    <video
                      v-if="item.type==='stream' || item.type==='screen'"
                      ref="streamVideos"
                      :id="item.clientId"
                      :srcObject = "item.stream"
                      autoplay playsinline
                      style="width:100%; height:100%; object-fit:cover;"
                      @click="focusItem(item,i)"
                    ></video>

                    <!-- static video file -->
                    <video v-else-if="item.type==='videoFile'"
                          :src="item.src"
                          autoplay
                          @click="focusItem(item,i)"
                    ></video>

                    <!-- webpage -->
                    <iframe v-else-if="item.type==='webpage'"
                            v-bind="{ 'data-clientid': item.clientId }"
                            :src="item.src"
                            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                            allowfullscreen
                            @click="focusItem(item,i)"
                    ></iframe>
                    <iframe v-if="item.type==='deskwebpage' && item.condition == 'Active'"
                            v-bind="{ 'data-clientid': item.clientId }"
                            :src="item.src"
                            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                            allowfullscreen
                            @click="focusItem(item,i)"
                    ></iframe>
                    <div v-if="item.type==='deskwebpage' && item.condition != 'Active'" class="overlay-mask"></div>

                    <iframe v-if="item.type==='deskwebpage' && item.condition != 'Active'"
                            v-bind="{ 'data-clientid': item.clientId }"
                            :src="item.src"
                            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                            allowfullscreen
                    ></iframe>
                    <!-- audio -->
                    <img   v-else-if="item.type==='audio'"
                          :src="item.avatar"
                          class="tile-avatar"
                          @click="focusItem(item,i)"
                    />

                    <!-- label only for streams -->
                    <div v-if="item.type==='stream' || item.type==='screen'" class="stream-label">{{ item.label }}</div>

                            <!-- Transparent overlay to capture focus click -->
                      <div class="tile-overlay" v-if="item.type==='webpage' || item.type==='deskwebpage' || item.type==='panelwebpage'" @click="focusItem(item)"></div>

                      <!-- Icon bar for non-webpage -->
                      <div v-if="item.type !== 'webpage'" class="icon-bar" style="display:none;">
                        <button :class="{ active: isMuted[i] }" @click.stop="toggleMute(i)">
                          <i :class="['fal', isMuted[i] ? 'fa-microphone-slash' : 'fa-microphone']"></i>
                        </button>
                        <button :class="{ active: isPlaying[i] }" @click.stop="togglePlay(i)">
                          <i :class="['fal', isPlaying[i] ? 'fa-pause' : 'fa-play']"></i>
                        </button>
                        <button @click.stop="toggleFullscreenTile(i)">
                          <i class="fal fa-expand"></i>
                        </button>
                        <div class="dropdown">
                          <button class="dropdown-toggle" @click.stop="toggleDropdown(i)">
                            <i class="fal fa-ellipsis-h"></i>
                          </button>
                          <ul v-if="dropdownOpen[i]" class="dropdown-menu">
                            <li @click.stop="option1(i)">Option 1</li>
                            <li @click.stop="option2(i)">Option 2</li>
                          </ul>
                        </div>
                      </div>

                      <div class="icon-bar" style="display:'';" v-if="item.type !== 'webpage' && activeTab == 'media'">
                          <!-- Mute / Unmute Audio -->
                          <button
                            title="Mute/Unmute Audio"
                            class="control-button"
                            :class="{ active: isMuted[i] }" 
                            @click.stop="toggleMute(i)"
                          >
                          <i :class="['far', isMuted[i] ? 'fa-microphone-slash' : 'fa-microphone']"></i>
                          </button>

                          <!-- Mute / Unmute Video -->
                          <button
                            title="Mute/Unmute Video"
                            class="control-button"
                            :class="{ active: isPlaying[i] }"
                            @click.stop="togglePlay(i)"
                          >
                            <i :class="['far', isPlaying[i] ? 'fa-video-slash' : 'fa-video']"></i>
                          </button>

                          <!-- Switch To Video -->
                          <button
                            title="Switch To Video"
                            class="control-button"
                            :class="{ active: isSwitchToVideo[i] }"
                            @click.stop = "switchToVideo(item,i)"
                          >
                            <i :class="['far', isSwitchToVideo[i] ? 'fa-camera' : 'fa-camera']"></i>
                        
                          </button>

                          <!-- Switch To Screen -->
                          <button
                            title="Switch To Screen"
                            class="control-button"
                            :class="{ active: isSwitchToScreen[i] }"
                            @click.stop = "switchToScreen(item,i)"
                          >
                          <i :class="['far', isSwitchToScreen[i] ? 'fa-desktop' : 'fa-desktop']"></i>
                          </button>

                          <!-- Disconnect (Moderator only) -->
                          <button
                            v-if="item.meetingContext.MeetingRole === 'Moderator'"
                            class="control-button active"
                            title="Disconnect"
                          >
                            <i class="fal fa-phone-slash" style="color:red"></i>
                          </button>

                          <!-- Kick Out (Moderator only) -->
                          <button
                            v-if="item.meetingContext.MeetingRole === 'Moderator'"
                            class="control-button active"
                            title="Kick out"
                          >
                            <i class="fal fa-user-times"></i>
                          </button>

                          <!-- Fullscreen -->
                          <button
                            class="control-button fullscreen-btn"
                            :class="{ active: fullscreenStates[i] }"
                            @click="toggleFullscreen(i)"
                          >
                            <i :class="fullscreenStates[i] ? 'fas fa-compress' : 'fas fa-expand'"></i>
                          </button>
                          <!-- Raised Hand Indicator -->
                          <button
                            v-if="startRaiseHandFlag && index === RaiseHandClientId"
                            class="control-button"
                            title="Raised Hand"
                            style="color: green;"
                          >
                            <i class="far fa-hand-paper"></i>
                          </button>

                          <!-- More Menu -->
                          <button
                            title="More…"
                            class="control-button more-button"
                          >
                            <i class="far fa-ellipsis-h"></i>
                          </button>
                          <div class="dropdown">
                          <button class="dropdown-toggle" @click.stop="toggleDropdown(i)">
                            <i class="fal fa-ellipsis-h"></i>
                          </button>
                          <ul v-if="dropdownOpen[i]" class="dropdown-menu">
                            <div class="menu-item">
                              <i class="fas fa-search-plus"></i>
                              <label>Zoom:</label>
                              <input
                                type="range"
                                :value="panrangeValue"
                                min="0"
                                max="100"
                              />
                            </div>
                            <div class="menu-item">
                              <i class="fas fa-arrows-alt-h"></i>
                              <label>Pan:</label>
                              <input
                                type="range"
                                :value="zoomrangeValue"
                                min="0"
                                max="100"
                              />
                            </div>
                            <div class="menu-item">
                              <i class="fas fa-arrows-alt-v"></i>
                              <label>Tilt:</label>
                              <input
                                type="range"
                                :value="tiltrangeValue"
                                min="0"
                                max="100"
                              />
                            </div>
                            <span class="close-media-player">×</span>

                          </ul>
                        </div>
                          <!-- Dropdown (always hidden unless parent toggles it via CSS/class) -->
                          <div v-if="activeMenu === index" class="bottom-menu dropdown-menu1">
                            <div class="menu-item">
                              <i class="fas fa-search-plus"></i>
                              <label>Zoom:</label>
                              <input
                                type="range"
                                :value="panrangeValue"
                                min="0"
                                max="100"
                              />
                            </div>
                            <div class="menu-item">
                              <i class="fas fa-arrows-alt-h"></i>
                              <label>Pan:</label>
                              <input
                                type="range"
                                :value="zoomrangeValue"
                                min="0"
                                max="100"
                              />
                            </div>
                            <div class="menu-item">
                              <i class="fas fa-arrows-alt-v"></i>
                              <label>Tilt:</label>
                              <input
                                type="range"
                                :value="tiltrangeValue"
                                min="0"
                                max="100"
                              />
                            </div>
                            <span class="close-media-player">×</span>
                          </div>
                      </div>

                      <div class="icon-bar" style="display:'';" v-if="item.type === 'deskwebpage' && activeTab == 'desk'">
                          <!-- dynamic overlay text -->
                          <div class="overlay-text">
                            {{ item.label }}  |
                            {{ item.condition }} 
                          </div>
                      </div>

                  </div>
              </div>

                   <!-- PANEL ITEMS -->
                <div v-if="activeTab === 'panels'">
                  <div
                    v-for="(item, i) in store.smartPanels"
                    :key= "id" 
                    class="video-tile"
                    @click="focusItem(item, i)"
                  >
                    <iframe
                      v-if="item.type==='panelwebpage'"
                      :src="item.src"
                       :data-clientid="item.clientId"
                      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                      allowfullscreen
                      :ref="el => panelFrames[idx] = el"
                      @click="focusItem(item, i)"
                    ></iframe>
                    <!-- overlay DIV catches clicks anywhere, even over the iframe: -->
                    <div
                      class="tile-overlay"
                      @click="focusItem(item, i)"
                    ></div>
                  
                   <div class="icon-bar" style="display:'';" v-if="item.type === 'panelwebpage' && activeTab == 'panels'">
                      
                          <!-- dynamic overlay text -->
                          <div class="overlay-text">
                            {{ item.subjectrole }}  |
                            {{ item.subjectDN }} 
                      </div>
                   </div>
                </div>
                </div>
       
        </div>          
              </div>
       

            </div>

             <!-- PARTICIPANTS -->
        <div v-if="activeTab === 'participants'">
          <div
            v-for="(p, idx) in participants"
            :key="`part-${p.id}-${idx}`"
            class="participant-row"
          >
            <i
              class="status-dot"
              :class="p.online ? 'online' : 'offline'"
              title="Status"
            ></i>
            <span class="participant-name">{{ p.name }}</span>
            <button
              class="call-btn"
              title="Invite"
              @click.stop="inviteParticipant(p)"
            >
              <i class="fas fa-phone"></i>
            </button>
          </div>
        </div>   
      
     
        <!-- Collapsed initials view -->
        <div v-else style="display:none;">
          <div
            v-for="(item, i) in mediaItems"
            :key="i"
            class="initial-tile"
            @click="focusItem(item,i); toggleOverlay()"
          >
            {{ getInitials(item.type) }}
          </div>
        </div>
       
      </div>

      <!-- Global controls (hidden) -->
      <div class="global-controls" style="display:none;">
        <button @click="reloadAll">Reload All</button>
      </div>

     
        <!-- Bottom persistent control bar -->
      <div class="bottom-bar">
        <button title="PSTN"
                class="control-button"
                :class="{active:startPstnFlag}"
                @click="startPstnFlag?handleStopPstn():handleStartPstn()"
        ><i :class="startPstnFlag?'far fa-phone':'far fa-phone-slash'"></i></button>

        <button title="Audio Call"
                class="control-button"
                :class="{active:startAudioFlag}"
                @click="startAudioFlag?handleStopAudio():handleStartAudio()"
        ><i :class="startAudioFlag?'far fa-phone-missed':'far fa-phone'"></i></button>

        <button title="Mute/Unmute"
                class="control-button"
                :class="{active:allMuted}"
                @click="allMuted?handleStopMute():handleStartMute()"
        ><i :class="allMuted?'far fa-microphone-slash':'far fa-microphone'"></i></button>

        <button title="Video"
                class="control-button"
                :class="{active:startVideoFlag}"
                @click="startVideoFlag?handleStopVideo():handleStartVideo()"
        ><i :class="startVideoFlag?'far fa-video-slash':'far fa-video'"></i></button>

        <button title="Screen Share"
                class="control-button"
                :class="{active:startScreenFlag}"
                @click="startScreenFlag?handleStopScreen():handleStartScreen()"
        ><i class="far fa-share-square"></i></button>

        <button title="Whiteboard"
                class="control-button"
                :class="{active:startWhiteboardFlag}"
                @click="startWhiteboardFlag?handleStopWhiteboard():handleStartWhiteboard()"
        ><i class="far fa-edit"></i></button>

        <button title="Recording"
                class="control-button"
                :class="{active:startRecordingFlag}"
                @click="startRecordingFlag?handleStopRecording():handleStartRecording()"
        ><i :class="startRecordingFlag?'far fa-dot-circle':'far fa-stop-circle'"></i></button>

        <button title="Chat"
                class="control-button"
                :class="{active:startChatFlag}"
                @click="startChatFlag ?handleStopChat():handleStartChat()"
        ><i :class="startChatFlag?'far fa-comment-alt':'far fa-comment'"></i></button>

        <button class="control-button" v-if="activeTab === 'media'" @click="handleRaiseHand()">
            <i class="far fa-hand-paper"></i>
        </button>

        <button title="Behaviour" v-if="activeTab === 'desk'"
                class="control-button"
                :class="{active:startBehaviourFlag}"
                @click="openPopup(focusedItem.src)"
        ><i class='far fa-circle-nodes fa-rotate-by'></i></button>

 <div class="tooltip-mc">
    <button
      title="Share"
      class="control-button"
      @click="copyToClipboard"
      @mouseout="outFunc"
    >
      <i class="far fa-share-alt"></i>
    </button>
    <span class="tooltiptext-mc" ref="myTooltip">Copy the Meeting Link</span>

    <div class="dndtextnode" v-show="showDnd" style="border: transparent;">
        <span class="description" style="color: #0072C5">
          Add Participant&nbsp;
        </span>
        <input
          type="text"
          class="dndtextnode"
          placeholder="Enter Email or Phone"
        />
        &nbsp;<span><i class="fa-solid fa-plus glyphiconRibbon"></i></span>
        <span class="description" style="color: white">
          Meeting&nbsp;<i class="fal fa-share-alt"></i>
        </span>
        &nbsp;&nbsp;
        <span class="description" style="color: white" ref="meetShortUrl1"></span>
        &nbsp;&nbsp;
      </div>
    </div>

        <button v-if="startPstnFlag  || startAudioFlag"
                title="Disconnect"
                class="control-button active"
                @click="handleStopMeeting()"
        ><i class="far fa-phone-slash" style="color:red"></i></button>

        <button title="More"
                class="control-button more-button"
                @click="toggleBottomMenu()"
        ><i class="far fa-ellipsis-h"></i></button>

        <div v-if="bottomMenuOpen" class="bottom-dropdown-menu">
          <button class="menu-item" style="display:none;" @click="handleOrderStatus()">
            <i class="fa fa-chart-line-up"></i> Order Status
          </button>
          <button class="menu-item" @click="handleOrderHistory()">
            <i class="far fa-eye"></i> Order History
          </button>
          <button class="menu-item" @click="handleSwitchToWindow()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="17" data-v-14d99e69=""><g fill="black" data-v-14d99e69=""><path d="M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v116h116c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v116H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h116v116c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12zm160 0V352h116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12z" data-v-14d99e69=""></path></g></svg> Switch To Window
          </button>
          <button class="menu-item" @click="openUserPopup(focusedItem.src)">
            <i class="far fa-user-plus"></i> Add Participant
          </button>
           <!-- Modal Backdrop -->
          <div
            v-if="showModal"
            class="modal-backdrop"
            @click.self="closeModal"
          >
            <div class="modal">
              <h2>Add Participant</h2>
              <input
                v-model="participant"
                type="text"
                placeholder="Enter Email or Phone"
                @keyup.enter="submitParticipant"
              />
              <div class="buttons">
                <button @click="closeModal">Cancel</button>
                <button @click="submitParticipant">Submit</button>
              </div>
            </div>
          </div>
        </div>
        
      </div>

  </div>
 </div> 
</template>

<script>
import { ref, onMounted,watch, nextTick,computed ,onBeforeUpdate ,onBeforeUnmount ,reactive ,defineExpose   } from 'vue';
import { useDraggable } from '@vueuse/core';
import { deviceStore } from './../stores/deviceStore'
 
//var vclientId = window.botStore.clients[0].Client;
//let client = window.botStore.getClientByID(vclientId);
//console.log("Got data for end call: ", client);


export default {
  name: 'MediaGrid',
  props: {
    index:             { type: Number, required: true },
    muteStatus:        { type: Array,   default: () => [] },
    playerVideoStates: { type: Boolean, default: false },
    playerScreenStates:{ type: Boolean, default: false },
    startRaiseHandFlag:  { type: Boolean, default: false },
    RaiseHandClientId:   { type: [Number,String], default: null },
    activeMenu:          { type: [Number,null], default: null },
    panrangeValue:       { type: Number,  default: 0 },
    zoomrangeValue:      { type: Number,  default: 0 },
    tiltrangeValue:      { type: Number,  default: 0 }
  },
   data: () => ({
    store: false,
  }),
  created() {
    this.store = deviceStore();
  },
  computed: {
    muteStatusForThis() {
      // fall back if undefined
      return this.muteStatus[this.index] || { audio: false, video: false };
    }
  },
  methods: {
   managePanels(panels) {
    console.log("Manage Panels got: ",panels);
    this.doSomethingCool(panels) ;
    }
  },
  setup() {
    

    const inputs = [
      { src: window.location.href, type: 'webpage' }
/*    { src: "https://debianlargeserver-0050-kamalk-0054.laxroute53.com/GraphsApp/WebixODE/index.html", type: 'webpage'}*/
/*      { src: 'https://www.w3schools.com/html/movie.mp4', type: 'videoFile' },
      { src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3', type: 'audio', avatar: 'https://avatar.iran.liara.run/public' }*/
    ];

    const deskInputs = [
      /*{ src: 'https://debianlargeserver-0050-kamalk-0054.laxroute53.com/DeepLander-0086/Tests/widget/frontdesktest.html', type: 'deskwebpage' },
       … */ 
    ];

    console.log("window location href ",window.location.href);
    console.log("window location document ",document.referrer);
    console.log("window location origin ",window.location.origin);
    
    let rootPanels = [];

    if(window.devStore && window.devStore.rootMenu && window.devStore.rootMenu.length > 0) {
     console.log("rootmenu panels :",window.devStore.rootMenu);
      rootPanels = window.devStore.rootMenu;
    }

//  const mediaItems = ref(inputs);
    const primaryVideo = ref(null)
    const streamVideos = ref([])
    //const panelItems = ref(rootPanels);
    const panelFrames = ref([]);
    const visible = ref(false);
    const fsEl    = ref(null);

    const mediaItems = ref([
      // your static URLs...
      ...inputs,
      // any live streams will get pushed here
    ]);

    const deskItems = ref([
      // your static URLs...
      ...deskInputs,
      // any live streams will get pushed here
    ]);

    const participants12 = ref([
      // example items; populate dynamically as you already do:
      { id: 1, name: "Alice Johnson", online: true },
      { id: 2, name: "Bob Smith",     online: false },
      // …
    ]);

    const panelItems= ref([
      { id:'1',src: "https://debianlargeserver-0050-kamalk-0054.laxroute53.com/DeepLander-0086/Tests/widget/frontdesktest.html",type:'panelwebpage' },
      { id:'2',src: "https://debianlargeserver-0050-kamalk-0054.laxroute53.com/GraphsApp/WebixODE/index.html" , type:'panelwebpage'}
      // …
    ]);

    function doSomethingCool(panels){
      console.log("setup funciton called",panels);

        panels.Action = 'add';

        if (!Array.isArray(panels)) return
        const action = (panels.Action || 'add').toLowerCase()
        panels.forEach(m => {
          const idx = panelItems.value.findIndex(x => x.id === m.ContainerID)
          const newItem = {
            type:       'panelwebpage',
            clientId:   m.dataset.clientid,
            src: `https://debianlargeserver-0050-kamalk-0054.laxroute53.com${m.URL}?clientID=${m.dataset.clientid}` || '',
            viewportID: m.viewportID,
            panelType:  m.MediaType,
            id:         m.ContainerID
          }
            
          if (action === 'add') {
            if (idx === -1) {
              panelItems.value.push(newItem)
            } else {
              panelItems.value.splice(idx, 1, newItem)
            }
          }
          else if (action === 'remove' && idx !== -1) {
            panelItems.value.splice(idx, 1)
          }
        })
      console.log("==panelItems got :",panelItems.value);
    }

    defineExpose(doSomethingCool);

    function show(event) {
      console.log('✅ show‑fullscreen event received!');
      console.log('payload:', event.detail);

      // the panel you want to show
      const el = document.getElementById('myFullScreen');
      if (!el) {
        console.error('element #myFullScreen not found!');
        return;
      }

      // elements by name="oxygen-container"
      const nodes = document.getElementsByName('oxygen-container');
      if (nodes.length === 0) {
        console.error('elements with name="oxygen-container" not found!');
        return;
      }

      el.style.display = 'flex';

      const first = nodes[0];
      console.log('Found oxygen-container element:', first);
      first.style.display = 'none';

      // If you wanted to affect *all* of them:
      // Array.from(nodes).forEach(node => {
      //   console.log('Hiding node:', node);
      //   node.style.display = 'none';
      // });

      // no fullscreen request since you only need a desktop‑fill panel
    }

    function showOld() {
      console.log('✅ show‑fullscreen event received!');
      const el = document.getElementById('myFullScreen');
      const mainoxygen = document.getElementById('CommAppWidgetsIdTwo');

      if (!el) {
        console.error('element #myFullScreen not found!');
        return;
      }

      if (!mainoxygen) {
        console.error('element oxygen page not found!');
        return;
      }

      // make it visible
      el.style.display = 'flex';            // or whatever your CSS expects
      mainoxygen.style.display = 'none';

      // then request fullscreen
      /*if (el.requestFullscreen) {
        el.requestFullscreen().catch(console.error);
      }*/
    }

    function hide() {
      const el = document.getElementById('myFullScreen');
      if (!el) {
        console.error('element #myFullScreen not found!');
        return;
      }

      // elements by name="oxygen-container"
      const nodes = document.getElementsByName('oxygen-container');
      if (nodes.length === 0) {
        console.error('elements with name="oxygen-container" not found!');
        return;
      }

      el.style.display = 'none';

      const first = nodes[0];
      console.log('Found oxygen-container element:', first);
      first.style.display = 'flex';
    }

    onMounted(() => {
      window.addEventListener('show-fullscreen', show);
      window.addEventListener('hide-fullscreen', hide);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('show-fullscreen', show);
      window.removeEventListener('hide-fullscreen', hide);
    });

    function inviteParticipant(p) {
      // your logic to invite, e.g.:
      window.top.BotServices.startCall({ ClientID: p.id, mediaType: "Audio" });

      let mode = "invite";let message = "";
      
      let inviteObj = {"to":{"tope":[],
                            "componentid":[],
                            "email":[],
                            "phone":[]},
                      "thread":client.value.ClientLeft,
                      "subject":client.value.ClientRight,
                      "ClientID" : client.value.Client,
                      "message":message,
                      "mode":mode,"callType":"MEETING","batchsize":'10',"dialerMode":"Meeting"};;
        (inviteObj.to.tope).push(p.member.PE);

        /*finalcontact.forEach((label)=>{
            (inviteObj.to.tope).push(p.member.PE);
        });*/
    
      window.top.BotServices.callManagerExec(inviteObj,()=>{});
    }

    const activeTab = ref('media');
    const focusedItem = ref(inputs[0]);
    const overlayVisible = ref(false);
    const isMuted     = ref(mediaItems.value.map(() => false))
    const isPlaying   = ref(mediaItems.value.map(() => false))
    const tilesContainer = ref(null)
    const isSwitchToVideo = ref(mediaItems.value.map(() => false))
    const isSwitchToScreen = ref(mediaItems.value.map(() => false))
    const isSwitchToFullScreen = ref(mediaItems.value.map(() => false))
    
    const dropdownOpen = ref(inputs.map(() => false));
    const tiles = ref([]);
    const draggables = ref([]);
    // bottom bar flags
    const startPstnFlag = ref(false);
    const startAudioFlag = ref(false);
    const allMuted = ref(false);
    const startVideoFlag = ref(false);
    const startScreenFlag = ref(false);
    const startWhiteboardFlag = ref(false);
    const startRecordingFlag = ref(false);
    const startBehaviourFlag = ref(false);
    const startChatFlag = ref(false);
    const startMeetingFlag = ref(false);
    const bottomMenuOpen = ref(false);
    const client = ref(null);
    const currentContext = ref(null);
    const meetingContext = ref(null);
    const locationContext = ref(null);
    const participants = ref([])
    const focusedStream = ref(null)
    const focusedClientId = ref(null)
    const showPopup = ref(false);
    const showUserPopup = ref(false);
    const popupUrl   = ref('');
    const showDnd = ref(false);
    const myTooltip = ref(null);
    const meetShortUrl = ref(null);
    const reloadKey = ref(0)
    const newparticipant = ref('');

    function submitParticipant() {
      const val = newparticipant.value.trim()
      if (!val) {
        console.warn('No value entered')
        return
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const phoneRegex = /^\+?\d{7,15}$/

      if (emailRegex.test(val)) {
        console.log('Entered value is an EMAIL:', val)
      }
      else if (phoneRegex.test(val)) {
        console.log('Entered value is a PHONE:', val)
      }
      else {
        console.log('Entered value is neither a valid email nor phone:', val)
      }
    }

    function copyToClipboard() {
      // your copy logic here
      // e.g. navigator.clipboard.writeText(meetingLink)
   
      let copyText = JSON.parse(client.value.MeetingURL).ShortURL;
      console.log("copy short url ",copyText);
      navigator.clipboard.writeText(copyText);

      var tooltip = myTooltip.value;
      tooltip.textContent = "Copied: " + copyText;
      showTooltip();
    }

    function showTooltip() {
      if (!myTooltip.value) return;
      myTooltip.value.style.visibility = 'visible';
      setTimeout(() => {
        myTooltip.value.style.visibility = 'hidden';
      }, 2000);
    }

    function outFunc() {
      if (myTooltip.value) {
        myTooltip.value.style.visibility = 'visible';
      }
    }
    
    function openUserPopup(url) {
      showUserPopup.value = true;
      toggleBottomMenu();
    }

    function closeUserPopup() {
      showUserPopup.value = false;
      popupUrl.value = '';
    }

    function openPopup(url) {
      showPopup.value = true;
      startBehaviourFlag.value = true;
    }

    function closePopup() {
      showPopup.value = false;
      popupUrl.value = '';
      startBehaviourFlag.value = false;
    }

    function openPopup1(url) {
      // create backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'iframe-backdrop';

      // create modal container
      const modal = document.createElement('div');
      modal.className = 'iframe-modal';

      // close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'iframe-close';
      closeBtn.textContent = '×';
      closeBtn.onclick = () => document.body.removeChild(backdrop);

      // the iframe itself
      const iframe = document.createElement('iframe');
      iframe.src = popupUrl.value;
      iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-popups allow-forms');
      iframe.allowFullscreen = true;
      iframe.className = 'iframe-content';

      modal.appendChild(closeBtn);
      modal.appendChild(iframe);
      backdrop.appendChild(modal);
      document.body.appendChild(backdrop);
    }

     // before each render, clear out old refs
    onBeforeUpdate(() => {
      tiles.value = []
    })

    // make sure isPlaying has same length
    onBeforeUpdate(() => {
      isPlaying.value = Array(mediaItems.value.length).fill(false)
    })

    onMounted(() => {
      draggables.value = tiles.value.map(el => useDraggable(el));
      tiles.value.forEach((tile, i) => {
        const video = tile.querySelector('video');
        const audio = tile.querySelector('audio.tile-audio');
        if (video) {
          video.onplay = () => (isPlaying.value[i] = true);
          video.onpause = () => (isPlaying.value[i] = false);
          video.onswitchtovideo = () => (isSwitchToVideo.value[i] = true);
          video.onswitchtoscreen = () => (isSwitchToScreen.value[i] = true);
        }
        if (audio) {
          audio.onplay = () => (isPlaying.value[i] = true);
          audio.onpause = () => (isPlaying.value[i] = false);
        }
      });
    });

    watch(mediaItems, async () => {
      await nextTick()  
      overlayVisible.value = true;
      mediaItems.value.forEach((item, idx) => {
        if (item.type === 'stream' || item.type === 'screen') {
          const vid = streamVideos.value[idx]
          if (vid && vid.srcObject !== item.stream) {
            vid.srcObject = item.stream
            vid.play().catch(console.error)
            overlayVisible.value = true;
            //focusedItem.value = item;
          }
        }
      })
    })

     watch(deskItems, async () => {
      await nextTick()  
      deskItems.value.forEach((item, idx) => {
        if (item.type === 'deskwebpage') {
          const vid = streamVideos.value[idx]
          if (vid && vid.src !== item.src) {
            vid.src = item.src
          }
        }
      })
    })

    watch(panelItems, async () => {
      await nextTick()  
      panelItems.value.forEach((item, idx) => {
        console.log("panelItems watch : ",item);
        if (item.type === 'panelwebpage') {
          console.log("panelItems watch : ",item);
          const vid = panelFrames.value[idx]
          if (vid && vid.src !== item.src) {
            vid.src = item.src
          }
        }
      })
    })

    const itemKey = (item, i) =>
      item.type === 'stream' ? `stream-${item.clientId}` : `static-${i}`

    //const focusItem = item => (focusedItem.value = item);
    function focusItem(item, i) {
      // special behavior only if you click the SAME stream twice
      const isSameStreamAgain =
        focusedItem.value === item &&
        (item.type === 'stream' || item.type === 'screen');

      if (isSameStreamAgain) {
        // bump the key so Vue tears down & re-creates the iframe/video
        reloadKey.value++;
        
        // your existing “switch to video” logic…
        const tiles = tilesContainer.value?.querySelectorAll('.video-tile');
        const tile  = tiles?.[i];
        if (!tile) return console.warn(`no tile at index ${i}`);
        const videoEl = tile.querySelector('video');
        if (!videoEl) return console.warn(`no <video> in tile ${i}`);
        
        const type = item.type === 'stream' ? 'Video' : 'Screen';
        const media = window.top.botStore.getStreamTypeByClient(videoEl.id, type);
        if (media?.Stream) {
          focusedItem.value.stream = media.Stream;
        }
      } 
      else {
        // absolutely _always_ reset focusedItem for ANY other click
        focusedItem.value = item;
      }

      console.log("focusedItem.value:", focusedItem.value);
      if(focusedItem.value.type == "panelwebpage") {
        getNodes(focusedItem.value.clientId);
      }
    }

    function focusItem12(item,i) {
      if (focusedItem.value === item && item.type === 'stream' || item.type == 'screen') {
        // bump the key so Vue tears down & re-creates the iframe
        reloadKey.value++
        const tiles = tilesContainer.value?.querySelectorAll('.video-tile')
        const tile  = tiles?.[i]
        if (!tile) {
          console.warn(`switchToVideo: no tile at index ${i}`)
          return
        }

        // find the <video> element inside that tile
        const videoEl = tile.querySelector('video')
        if (!videoEl) {
          console.warn(`switchToVideo: no <video> in tile ${i}`)
          return
        }

        console.log('handle switch to Video clicked:', i)
        let type = 'Screen';

        if(item.type == 'stream') {
            type = 'Video';
        }
        // assume your BotStore helper is globally available
        const media = window.top.botStore.getStreamTypeByClient(videoEl.id, type)
        if (media?.Stream) {
          focusedItem.value.stream = media.Stream
        } else {
          console.warn('switchToVideo: no Video stream found for client', videoEl.id)
        }
        
      } else {
        focusedItem.value = item
      }
      console.log("focusedItem :",focusedItem);
    }
  
    function focusStream(item) {
      focusedItem.value = item
    }

    const toggleOverlay = () => (overlayVisible.value = !overlayVisible.value);
    const getInitialsOld = src =>
      src
        ? new URL(src).host.replace('www.', '').split('.').map(p => p[0].toUpperCase()).join('')
        : '';

     const getInitials = type =>
      type
        ? type
        : '';

     // subscribe to meeting member events
     const channel = window.BotServices.getBotEventChannel({ EventName: 'MeetingMembers' })
     channel?.subscribe({ next: manageMeetingMembers })

     const handleSwitchToWindow = () => {
         window.top.dispatchEvent(new Event('hide-fullscreen'));
     }

    // handlers
    const handleStartPstn = () => {
      if (!client.value) {
        return console.warn('No client yet');
      } else {
        console.log("handle start pstn",client.value);
      }
    
      startPstnFlag.value = true;
      console.log("handle start Pstn");

      let callerAudioFlag = false, callerVideoFlag = false, callerScreenFlag = false;
      let params = {"ClientID":client.value.Client,"ToPE":null,"mediaType":"Audio"};
      
      if(params.mediaType == "Screen") {
        callerScreenFlag = true;
      } else if(params.mediaType == "Video") {
        callerVideoFlag = true;
      }
      let CallPE = params.ToPE;
      let InitialContext = {Caller:{Audio:callerAudioFlag,NoShow:true,Screen:callerScreenFlag,Video:callerVideoFlag,Pstn:true},Callee:{Audio:true,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
      let callObj = {Mode:"STARTMEDIA" ,ClientID:params.ClientID,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
      window.top.BotServices.startCall(callObj);

    }

    const handleStopPstn = () => {
      startPstnFlag.value = false;
      console.log("handle stop Pstn");
      window.top.BotServices.stopMedia({ClientID : client.value.Client, MediaType : 'Pstn' });
   
    }

    const handleStartAudio = () => {
      startAudioFlag.value = true;
      let CallObj = {"ClientID":client.value.Client,"ToPE":'',"mediaType":"Audio"};
      window.top.DevMgr.startMedia(null,client.value.Client,CallObj);
    }

    const handleStopAudio = () => {
      startAudioFlag.value = false; 
      window.top.BotServices.stopMedia({ClientID : client.value.Client, MediaType : 'Audio' });
    }

    const handleStartMute = () => {
      allMuted.value = true;
    }

    const handleStopMute = () => {
      allMuted.value = false;
    }

    const handleStartVideo = () => {
      startVideoFlag.value = true;
      //toggleSelfVideo();
      // let CallPE = currentContext.ToPE;
      let CallObj = {"ClientID":client.value.Client,"ToPE":'',"mediaType":"Video"};
      let viewportid  = "";
      window.top.DevMgr.startMedia(viewportid,client.value.Client,CallObj);
    }

    const handleStopVideo = () => {
      startVideoFlag.value = false;
      window.top.BotServices.stopMedia({ClientID : client.value.Client, MediaType : 'Video' });
    }

    const handleStartScreen = () => {
      startScreenFlag.value = true;
      console.log("handle start screen");
      let viewportid = "";
      let CallObj = {"ClientID":client.value.Client,"ToPE":'',"mediaType":"Screen"};
      window.top.DevMgr.startMedia(viewportid,client.value.Client,CallObj);

    }

    const handleStopScreen = () => {
      startScreenFlag.value = false;
      console.log("handle stop screen");
      window.top.BotServices.stopMedia({ClientID : client.value.Client, MediaType : 'Screen' });
  
    }

    const handleStartWhiteboard = () => {
      startWhiteboardFlag.value = true;
      console.log("handle start whiteboard");
      //let terminationUrl = {"MediaType":"Iframe","URL":"/WhiteBoard-0052/tldraw/index.html?meetingId="+meetingContext.value.MeetingParentId};
      //window.top.BotServices.openChildPanel({ClientID : client.value.Client, DisplayName : 'Whiteboard', Termination : terminationUrl, "Template":"oxygen-whiteboard",CssLink:"/WhiteBoard-0052/tldraw/static/css/main.e6c13ad2.css"}, ()=>{});
      
      const newPage = {
        type:     'webpage',
        clientId: client.value.Client,
        src:      `/WhiteBoard-0052/tldraw/index.html?meetingId=${meetingContext.value.MeetingParentId}`,
        meetingContext: meetingContext.value
      };

      // 1) push into the reactive array
        mediaItems.value.push(newPage);

      // 2) open the overlay (if it’s collapsed)
        overlayVisible.value = true;

      // 3) focus the new item
        focusedItem.value = newPage;
    }

    const handleStopWhiteboard = () => {
      startWhiteboardFlag.value = false;
      console.log("handle stop whiteboard");
      window.top.BotServices.stopMedia({ClientID : client.value.Client, MediaType : 'Data' });
    }
    
    const handleStartRecording = () => {
      console.log("handle start recording");
      startRecordingFlag.value = true;
       window.top.DevMgr.startRecording(null,client.value.Client);
    }

    const handleStopRecording = () => {
      console.log("handle stop recording");
      startRecordingFlag.value = false;
      window.top.DevMgr.stopRecording(null,client.value.Client);
    }

    const handleStartChat = () => {
      startChatFlag.value = true;
      window.top.dispatchEvent(new CustomEvent("showMessageUs"));
    }

    const handleStopChat = () => {
      startChatFlag.value = false;
    }

    const handleStopMeeting = () => {
      startMeetingFlag.value = false;
    }

    const handleOrderHistory = () => {
      toggleBottomMenu();
      // window.top.DevMgr.GetBehaviourHistory(client.value,()=>{});
      console.log("order history :", {
          ClientID: client.value.Client,
          GrantID: currentContext.value.grantItem.GrantID,
          ComponentID: client.value.ClientRight
        });
      
      const newPage = {
        type:     'webpage',
        clientId: client.value.Client,
        src:      `/DeepLander-0086/CRMV2/Spreadsheet/kanban_order_status.html?clientID=${client.value.Client}&GrantID=${currentContext.value.grantItem.GrantID}&ComponentID=${client.value.ClientRight}`,
        meetingContext: meetingContext.value
      };

        mediaItems.value.push(newPage);

        //overlayVisible.value = true;

        focusedItem.value = newPage;

    }

    const handleOrderStatus = () => {
      toggleBottomMenu();
      const newPage = {
        type:     'webpage',
        clientId: client.value.Client,
        src:      `/GraphsApp/OrderStatus/index.html?clientID=${client.value.Client}`,
        meetingContext: meetingContext.value
      };

      // 1) push into the reactive array
        mediaItems.value.push(newPage);

      // 2) open the overlay (if it’s collapsed)
        //overlayVisible.value = true;

      // 3) focus the new item
        focusedItem.value = newPage;
    };

    function ensureRaiseHandStyles() {
      if (document.getElementById('raise-hand-styles')) return;

      const css = `
        #raise-hand-container {
          position: fixed;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          pointer-events: none;
          z-index: 9999;
        }
        .raise-hand-notification {
          display: inline-flex;
          align-items: center;
          background: rgba(0,123,255,0.9);
          color: white;
          padding: 8px 12px;
          margin: 4px 0;
          border-radius: 20px;
          font-family: sans-serif;
          font-size: 14px;
          opacity: 0;
          animation: flyUpFade 3s ease-in-out forwards;
        }
        .raise-hand-notification .icon {
          margin-right: 8px;
          font-size: 18px;
        }
        @keyframes flyUpFade {
          0%   { transform: translateX(-50%) translateY(100px) scale(0.8); opacity: 0; }
          10%  { opacity: 1; }
          80%  { transform: translateX(-50%) translateY(-200px) scale(1); opacity: 1; }
          100% { transform: translateX(-50%) translateY(-300px) scale(1.2); opacity: 0; }
        }
      `;
      const style = document.createElement('style');
      style.id = 'raise-hand-styles';
      style.textContent = css;
      document.head.appendChild(style);
    }


    function handleRaiseHand() {
      ensureRaiseHandStyles();      // if you still need the keyframes
      
      window.top.BotServices.callManagerApi({action: 'raiseHand', data : { MeetingContext:meetingContext.value, currentContext:currentContext.value }});
      toggleBottomMenu();
    }

    function showRaiseHand(name) {
    
      const container = document.getElementById('raise-hand-container');
      if (!container) return;

      const notif = document.createElement('div');
      // updated inline CSS
      Object.assign(notif.style, {
        position:       'fixed',
        bottom:         '20px',             // give a little breathing room
        left:           '50%',
        transform:      'translateX(-50%)',
        display:        'inline-flex',
        alignItems:     'center',
        whiteSpace:     'nowrap',           // ← prevent wrapping
        background:     '#0072C5',
        color:          'white',
        padding:        '8px 16px',         // wider padding so text never wraps
        margin:         '0',
        borderRadius:   '20px',
        fontFamily:     'sans-serif',
        fontSize:       '14px',
        opacity:        '0',
        animation:      'flyUpFade 3s ease-in-out forwards',
        zIndex:         '9999',
        pointerEvents:  'none',
        boxShadow:      '0 2px 8px rgba(0,0,0,0.2)'  // optional drop shadow
      });

      const icon = document.createElement('span');
      icon.textContent = '✋';
      Object.assign(icon.style, {
        marginRight: '8px',
        fontSize:    '18px'
      });

      const text = document.createElement('span');
      text.textContent = `${name} has raised their hand`;

      notif.append(icon, text);
      container.appendChild(notif);

      notif.addEventListener('animationend', () => notif.remove());
    }

    // make sure to clean up container on unmount:
    onBeforeUnmount(() => {
      const container = document.getElementById('raise-hand-container');
      if (container) container.innerHTML = '';
    });

    const handleAddParticipant = () => {};
    const toggleBottomMenu = () => bottomMenuOpen.value = !bottomMenuOpen.value;

    const reloadAll = () => {
      tiles.value.forEach((tile, i) => {
        const item = mediaItems.value[i];
        const el = tile.querySelector(item.type === 'webpage' ? 'iframe' : 'video');
        if (item.type === 'webpage') el.src = el.src;
        else { el.currentTime = 0; el.play(); }
      });
    };

    function toggleMute(i) {
      const tiles = tilesContainer.value?.querySelectorAll('.video-tile')
      const tile  = tiles?.[i]
      if (!tile) {
        console.warn(`toggleMute: no tile at index ${i}`)
        return
      }

      // look for either a <video> or an <audio> inside that tile
      const mediaEl = tile.querySelector('video, audio')
      if (!mediaEl) return

      mediaEl.muted = !mediaEl.muted
      isMuted.value[i] = mediaEl.muted
    }


    function togglePlay(i) {
      const tiles = tilesContainer.value
        ?.querySelectorAll('.video-tile')
      const tile = tiles?.[i]
      if (!tile) {
        console.warn(`togglePlay: no tile at index ${i}`)
        return
      }
      const vid = tile.querySelector('video')
      if (!vid) return

      if (vid.paused) {
        vid.play().catch(console.error)
        isPlaying.value[i] = true
      } else {
        vid.pause()
        isPlaying.value[i] = false
      }
    }



    function switchToVideo(item,i) {
      
      const tiles = tilesContainer.value?.querySelectorAll('.video-tile')
      const tile  = tiles?.[i]
      if (!tile) {
        console.warn(`switchToVideo: no tile at index ${i}`)
        return
      }

      // find the <video> element inside that tile
      const videoEl = tile.querySelector('video')
      if (!videoEl) {
        console.warn(`switchToVideo: no <video> in tile ${i}`)
        return
      }

      console.log('handle switch to Video clicked:', i)

      // assume your BotStore helper is globally available
      const media = window.top.botStore.getStreamTypeByClient(videoEl.id, 'Video')
      if (media?.Stream) {
        videoEl.srcObject = media.Stream
        videoEl.play().catch(err => console.error('play error', err))
      } else {
        console.warn('switchToVideo: no Video stream found for client', videoEl.id)
      }
      item.type = 'stream';
      focusItem(item,i);
    }


    function switchToScreen(item,i) {
      
      const tiles = tilesContainer.value?.querySelectorAll('.video-tile')
      const tile  = tiles?.[i]
      if (!tile) {
        console.warn(`switchToScreen: no tile at index ${i}`)
        return
      }

      // find the <video> element inside that tile
      const videoEl = tile.querySelector('video')
      if (!videoEl) {
        console.warn(`switchToScreen: no <video> in tile ${i}`)
        return
      }

      console.log('handle switch to Video clicked:', i)

      // assume your BotStore helper is globally available
      const media = window.top.botStore.getStreamTypeByClient(videoEl.id, 'Screen')
      if (media?.Stream) {
        videoEl.srcObject = media.Stream
        videoEl.play().catch(err => console.error('play error', err))
      } else {
        console.warn('switchToVideo: no Video stream found for client', videoEl.id)
      }
      item.type = 'screen';
      focusItem(item,i);
    }

    const fullscreenStates = reactive({});

    function toggleFullscreen(i) {
      const vid = videoRefs.value[i];
      if (!vid) return;

      // if not currently fullscreen, request it
      if (!fullscreenStates[i]) {
        if (vid.requestFullscreen) vid.requestFullscreen();
        else if (vid.webkitRequestFullscreen) vid.webkitRequestFullscreen();
        else if (vid.mozRequestFullScreen) vid.mozRequestFullScreen();
        else if (vid.msRequestFullscreen) vid.msRequestFullscreen();
      }
      else {
        // exit fullscreen
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
      }

      // flip the reactive flag
      fullscreenStates[i] = !fullscreenStates[i];
    }

    const toggleFullscreenTile = i => {
      const el = tiles.value[i];
      !document.fullscreenElement ? el.requestFullscreen() : document.exitFullscreen();
    };

    const toggleDropdown = i => {
      dropdownOpen.value[i] = !dropdownOpen.value[i];
    };

     if(window.BotServices && window.BotServices.Events) {
      botStoreSubscribe();
    } else {
      window.addEventListener("botServicesLoaded", (event) => {
        botStoreSubscribe();
      });
    }

    function botStoreSubscribe() {
      window.BotServices.Events.subscribe({
        next : ((event) => {
          console.log("got subscribe smart meeting event",event);
          if(event.Clients && event.Clients.length > 0) {
            event.Clients.forEach((c) => {
              console.log("got subscribe smart meeting event client",c);
              
              c.clientID = c.Client;
              client.value = c;
              currentContext.value = JSON.parse(c.CurrentContext);
              meetingContext.value = JSON.parse(c.MeetingContext);
             
              console.log("got subscribe smart meeting event client set",client.value);
              popupUrl.value = "/GraphsApp/WebixBehaviour/index.html?clientID="+client.value.Client+"&nodeId="+client.value.ClientRight;
              
              if(client.value && client.value.MeetingURL) {
                let meetingurl = JSON.parse(client.value.MeetingURL);
                meetShortUrl.value = meetingurl.ShortURL;
                console.log("meet short url :",meetShortUrl.value);
              }

              
          
              subscribeMediaEvents();
              getNodes(client.value.Client);

              //store.addClient(c);
              //store.initBehaviour(c);
            });
          } else if(event.Triggers) {
             console.log("Got client trigger",event.Triggers);
             if(event.Triggers.Type == "DeskTrigger") {
              getNodes(event.Triggers.Data.Client);
             }
          }
        }),
      });
    }

    function subscribeMediaEvents() {
      console.log("smart meeting subscribe media events",client.value.Client);
      if(window.BotServices) {
        let pubState = window.BotServices.getPublisherStates(client.value.Client);
        console.log("smart meeting pubstate",pubState);
              
        let meetingChannel = window.BotServices.getBotEventChannel({EventName : 'MeetingEvents'});
        console.log("smart meeting meetingChannel : ", meetingChannel);
        if(meetingChannel) {
          meetingChannel.subscribe({
              next : ((event) => {
                  console.log(" smart meeting MeetingEvent : ", event);
                  manageMeetingMembers(event);              
                }),
          });
        }

        let streamChannel = window.BotServices.getBotEventChannel({EventName : 'StreamEvents'});
        console.log("smart meeting  StreamChannel : ", streamChannel);
        if(streamChannel) {
          streamChannel.subscribe({
              next : ((event) => {
                  console.log("smart meeting StreamEvent : ", event);
                  manageMediaStreams(event);              
                }),
          });
        }
  

        window.BotServices.subscribeToEvents({ClientID : client.value.Client, EventType : 'CallManager'}, (err, callMgrEvent) => {
          console.log("smart meeting callMgrEvent : ", callMgrEvent);
          if(callMgrEvent) {
            if(callMgrEvent.Name == "RaisedHand") {
                console.log("==got raise hand event",callMgrEvent.Data.currentContext.ClientId,"======",mediaItems.value);

                const match = participants.value.find(m => m.clientId === callMgrEvent.Data.currentContext.ClientId);
                if (match) {
                  console.log("Found via find():", match.name);
                  showRaiseHand(match.name);
                }
                //RaiseHandClientId = callMgrEvent.Data.currentContext.clientNodeId;
              //  setRaiseHandClientId(callMgrEvent.Data.currentContext.clientNodeId);
                //if(client.Client == callMgrEvent.Data.currentContext.clientNodeId) {
                //  setRaiseHandFlag(true);
                //}
                //handleClientStates(callMgrEvent);
              } 
          }
        /* if(callMgrEvent) {
              if(callMgrEvent.Name == 'EndCall') {
              // handleButtonStates();
              // handlePlayerStates(callMgrEvent);
              } else if(callMgrEvent.Name == 'EndClient') {
                handleClientStates(callMgrEvent);
              } else if(callMgrEvent.Name == 'PublisherState') {
                  if(callMgrEvent.Data.MediaType == 'Pstn' && callMgrEvent.Data.State == true) {
                    setstartPstnFlag(true);
                  } 
                  if(callMgrEvent.Data.MediaType == 'Pstn' && callMgrEvent.Data.State == false) {
                    setstartPstnFlag(false);
                  }
                  if(callMgrEvent.Data.MediaType == 'Audio' && callMgrEvent.Data.State == true) {
                    setstartAudioFlag(true);
                  }
                  if(callMgrEvent.Data.MediaType == 'Audio' && callMgrEvent.Data.State == false){
                    setstartAudioFlag(false);
                  }
                  if(callMgrEvent.Data.MediaType == 'Video' && callMgrEvent.Data.State == true) {
                    setstartVideoFlag(true);
                  } 
                  if(callMgrEvent.Data.MediaType == 'Video' && callMgrEvent.Data.State == false) {
                    setstartVideoFlag(false);
                  }
                  if(callMgrEvent.Data.MediaType == 'Screen' && callMgrEvent.Data.State == true) {
                    setstartScreenFlag(true);
                  } 
                  if(callMgrEvent.Data.MediaType == 'Screen' && callMgrEvent.Data.State == false) {
                    setstartScreenFlag(false);
                  }
                  if(callMgrEvent.Data.MediaType == 'Chat' && callMgrEvent.Data.State == true) {
                    setstartChatFlag('meeting');
                  } 
                  if(callMgrEvent.Data.MediaType == 'Chat' && callMgrEvent.Data.State == false) {
                    setstartChatFlag('all');
                  }
                  if(callMgrEvent.Data.MediaType == 'Data' && callMgrEvent.Data.State == true) {
                    setStartWhiteboardFlag(true);
                  } 
                  if(callMgrEvent.Data.MediaType == 'Data' && callMgrEvent.Data.State == false) {
                    setStartWhiteboardFlag(false);
                  }
                  if(callMgrEvent.Data.Muted == true) {
                    setAllMuted(true);
                  }
                  if(callMgrEvent.Data.Muted == false) {
                    setAllMuted(false);
                  }
              } else if(callMgrEvent.Name == "RaisedHand") {
                console.log("==got raise hand event",callMgrEvent.Data.currentContext.clientNodeId);
                //RaiseHandClientId = callMgrEvent.Data.currentContext.clientNodeId;
                setRaiseHandClientId(callMgrEvent.Data.currentContext.clientNodeId);
                //if(client.Client == callMgrEvent.Data.currentContext.clientNodeId) {
                  setRaiseHandFlag(true);
                //}
                //handleClientStates(callMgrEvent);
              }
          }*/
        });
      }
    }


    // fullscreen detection
    const isFullscreen = ref(false)
    function onFullScreenChange() {
      isFullscreen.value = !!document.fullscreenElement
    }

    // --- Meeting participants ---
  
    function adjustVideoLayout12() {
      const items = document.querySelectorAll('.video-item')
      if (items.length===1) items[0].classList.add('fullscreen')
      else items.forEach(i=>i.classList.remove('fullscreen'))
    }
    function manageMeetingMembers12(evt) {
      let clientObj = window.botStore.getClientByID(client.value.Client);
      let currentContext = JSON.parse(clientObj.CurrentContext);
      let LocationContext = JSON.parse(clientObj.LocationContext);

      const handleAdd = m=>{
        if (m.MeetingParentID!==MeetingContext.MeetingParentId) return
        const ctx = JSON.parse(m.CurrentContext||'{}')
        let name='Visitor-'+(ctx.grantItem?.GrantLeftID||'')
        if(ctx.Account) name=ctx.Account.email||ctx.Account.phone_number||name
        participants.value.push({...m,participantName:name,
          audio:false,video:false,screen:false,
          isVideoOn:false,isAudioOn:false,isScreenSharing:false,
          isRecording:false,isCallOn:false,isFullscreen:false})
       // setTimeout(adjustVideoLayout,0)
      }
      if(evt?.Action==='Add') handleAdd(evt.Member)
      else if(!evt) {
        window.top.botStore.meetings
          .filter(x=>x.MeetingParentID===MeetingContext.MeetingParentId)
          .forEach(handleAdd)
        attachExistingMedia()
      }
    }
    function attachExistingMedia12(){
      setTimeout(()=>{
        (window.top.botStore.streams||[])
          .filter(s=>s.MeetingId===MeetingContext.MeetingParentId && ['Video','Screen'].includes(s.MediaType))
          .forEach(s=>{
            const el=document.getElementById(s.ClientId)
            if(el?.tagName==='VIDEO'){ el.srcObject=s.Stream; el.play()
              .then(()=>updateVideoState({id:s.ClientId,state:'Play'}))
              .catch(console.error)
              avatarStatus.current[s.ClientId]=false
            }
          })
      },500)
    }

    function processString(preOrderID) {
        
      // Check if the string is 36 characters long and starts/ends with an underscore
      if (preOrderID.length === 36 && preOrderID.startsWith('_') && preOrderID.endsWith('_')) {
        // Remove underscores
        const sanitizedString = preOrderID.replace(/_/g, '');

        // Get the last 4 characters
        const lastFour = sanitizedString.slice(-4);

        // Prepend '#' and return
        return `${lastFour}`;
      } else {
        // Return a message or handle the case where the string does not meet the criteria
        return 'Invalid';
      }
    }

   function manageExistingMembers() {
      window.top.botStore.meetings.forEach((member) => {
        if(member.MeetingParentID == MeetingContext.MeetingParentId) {
          let memberContext = JSON.parse(member.CurrentContext);
          let memberGrantLeftId = (member) ? member.ClientID : "";
          let displayName = "Visitor - " + processString(memberGrantLeftId);;
    
          if(memberContext && memberContext.Account) {
            displayName = (memberContext.Account.email) ? memberContext.Account.email : memberContext.Account.phone_number;
          }
          member.participantName = displayName;
          member.audio = false;
          member.video = false;
          member.screen = false;
          // member.url = null;
          // member.stream = null;
          console.log("adding member",member,memberContext);
          mediaItems.value.push({
            type:           'stream',   // or however you want to distinguish
            clientId:       member.Client,
            participantName: displayName,
            stream:         null,            // will be filled by manageMediaStreams
            meetingContext  : meetingContext.value
            // any other flags you like…
          });
        }
      });
   }

   function manageDeskStreams(desks,clientId) {
      if (!Array.isArray(desks)) return
      desks.Action = 'add';
      const action = (desks.Action||'').toLowerCase()

      desks.forEach(m => {
        m.ClientId = clientId;

        //if (!['video','screen'].includes(m.MediaType.toLowerCase())) return
        const idx = deskItems.value.findIndex(x => x.id === m.Node.ID)
        console.log("node value in desk",idx);

        if (action === 'add') {
          /*const newItem = {
              type:          'deskwebpage',
              clientId:      clientId,
              src:           (m && m.Component && m.Component.InitialContext && m.Component.InitialContext.Termination.URL) ? m.Component.InitialContext.Termination.URL : "/DeepLander-0086/ConversationBots/MarketplaceAI/desk.html",
              condition:     m.Node.Condition,
              label:         m.Node.Label,
              id:            m.Node.ID,
              role:          m.Node.ArgJSON.Role,
              action:        m.Node.ArgJSON.Action,
              result:        m.Node.ArgJSON.Results,
              nodecomponent: m.Component,
              nodeObj:       m.Node
            };*/
           const newItem = {
              type:          'deskwebpage',
              clientId:      clientId,
              src:           m?.Component?.InitialContext?.Termination?.URL 
                              ?? `/DeepLander-0086/ConversationBots/MarketplaceAI/desk.html?Label=${(m?.Node?.Label ?? '')}`,
              condition:     m?.Node?.Condition,
              label:         m?.Node?.Label,
              id:            m?.Node?.ID,
              role:          m?.Node?.ArgJSON?.Role,
              action:        m?.Node?.ArgJSON?.Action,
              result:        m?.Node?.ArgJSON?.Results,
              nodecomponent: m?.Component,
              nodeObj:       m?.Node
            };
          if (idx === -1) {
              deskItems.value.push(newItem);

          } else {
            deskItems.value[idx].src = m?.Component?.InitialContext?.Termination?.URL 
                              ?? `/DeepLander-0086/ConversationBots/MarketplaceAI/desk.html?Label=${(m?.Node?.Label ?? '')}`
            // existing item → clear everything, then push the new one
            deskItems.value.splice(0, deskItems.value.length);
            deskItems.value.push(newItem);
          }
          console.log('deskItems ',deskItems);
        }
        else if (action === 'remove' && idx !== -1) {
          deskItems.value.splice(idx, 1)
        }
      })
    }

  
    function manageMeetingMembers(event) {
        let MeetingContext = meetingContext.value;

         if(event) {
          if(event.Action == "Add") {
            let member = event.Member;

            if(member.MeetingParentID == MeetingContext.MeetingParentId) {
              let memberContext = JSON.parse(member.CurrentContext);
              let memberGrantLeftId = (member ) ? member.ClientID : "";
              let displayName = "Visitor - " + processString(memberGrantLeftId);

              if(memberContext && memberContext.Account) {
                displayName = (memberContext.Account.email) ? memberContext.Account.email : memberContext.Account.phone_number;
              }
              member.participantName = displayName;
              // member.url = null;
              // member.stream = null;
              member.audio = false;
              member.video = false;
              member.screen = false;
              member.isVideoOn = false;
              member.isAudioOn = false;
              member.isScreenSharing = false;
              member.isRecording = false;
              member.isCallOn = false;
              member.isFullscreen = false;
              console.log("adding member",member,memberContext);
              
              /*mediaItems.value.push({
                type:           'stream',   // or however you want to distinguish
                clientId:       member.Client,
                participantName: name,
                stream:         null,            // will be filled by manageMediaStreams
                meetingContext  : meetingContext.value
                // any other flags you like…
              });*/
              let memberStatus = false;

              if(member.Status == "AVAILABLE") {
                  memberStatus = true;
              } else {
                  memberStatus = false;
              }

              console.log("participants : ",participants.value,"===",member.ID,"===",member.participantName);
             if (!participants.value.some(p => p.name === member.participantName)) {
                participants.value.push({
                  id:      member.ID,
                  name:    member.participantName,
                  online:  memberStatus,
                  member:  member,
                  clientId:member.Client
                });
              }
            }
          }

        } else {
          attachExistingMedia();
        }
    }

    function manageMeetingMembersOld(event) {
      console.log("botstore meetings",window.top.botStore.streams);
      const addOne = member => {
//        if (member.MeetingParentID !== MeetingContext.MeetingParentId) return

        const ctx = JSON.parse(member.CurrentContext || '{}')
        let name = 'Visitor – ' + (ctx.grantItem?.GrantLeftID || '')
        if (ctx.Account) {
          name = ctx.Account.email || ctx.Account.phone_number || name
        }

       /* mediaItems.value.push({
          type:           'stream',   // or however you want to distinguish
          clientId:       member.Client,
          participantName: name,
          stream:         null,            // will be filled by manageMediaStreams
          meetingContext  : meetingContext.value
          // any other flags you like…
        })*/

        // Wire up any already-publishing streams for this client:
        const existing = (window.top.botStore.streams || []).filter(
          s => s.ClientId === member.Client &&
              ['video','screen'].includes(s.MediaType)
        )
        if (existing.length) {
          manageMediaStreams({ Action: 'Add', Streams: existing })
        }

        // layout
       // window.addEventListener('resize', adjustVideoLayout)
        //document.addEventListener('DOMContentLoaded', adjustVideoLayout)
        //setTimeout(adjustVideoLayout, 0)
      }

      if (event?.Action === 'Add') {
        addOne(event.Member)
      }
      else if (!event) {
        // initial load
        window.top.botStore.meetings
          .filter(m => m.MeetingParentID === MeetingContext.MeetingParentId)
          .forEach(addOne)
        // wire up any streams that already exist
        setTimeout(() => {
          manageMediaStreams({
            Action:  'Add',
            Streams: window.top.botStore.streams || []
          })
        }, 500)
      }
    }

    onMounted(() => {
      // subscribe meeting-member events
      window.top.BotServices
        .getBotEventChannel({ EventName: 'MeetingMembers' })
        ?.subscribe({ next: manageMeetingMembers })

      // bootstrap initial members
      manageExistingMembers();
    })

   function manageMediaStreams(event) {
      if (!Array.isArray(event.Streams)) return
      const action = (event.Action||'').toLowerCase()

      event.Streams.forEach(m => {
        if (!['video','screen'].includes(m.MediaType.toLowerCase())) return
        const idx = mediaItems.value.findIndex(x => x.clientId === m.ClientId)
        console.log("Delete media ",action,"==",idx);
        
        if (action === 'add') {
          if (idx === -1) {
            if(m.MediaType == "Screen") {
              let newStreamScreen = {
                  type:     'screen',
                  clientId: m.ClientId,
                  stream:   m.Stream,
                  meetingContext : meetingContext.value
                };
               
                mediaItems.value.push(newStreamScreen);
               // focusedItem.value = newStreamScreen;
            } else {
                let newStream = {
                  type:     'stream',
                  clientId: m.ClientId,
                  stream:   m.Stream,
                  meetingContext : meetingContext.value
                };
                mediaItems.value.push(newStream);
                //focusedItem.value = newStream;
            }
          } else {
            mediaItems.value[idx].stream = m.Stream
          }
        }
        else if (action === 'del' && idx !== -1) {
          console.log("Delete media ",m.Stream,"==",idx);
           const clientIdStr = String(m.ClientId);

          const videoEl = document.getElementById(clientIdStr);
          console.log("client id to remove element",videoEl);

          if (videoEl) {
            // stop any tracks to free camera/mic
            const stream = videoEl.srcObject;
            if (stream && stream.getTracks) {
              stream.getTracks().forEach(track => track.stop());
            }
            videoEl.remove();
          }
          
          console.log("client id to remove",clientIdStr,"====",mediaItems.value);
          mediaItems.value = mediaItems.value.filter(item =>
            String(item.clientId) !== clientIdStr
          );
   
        }
      })
    }

    function executeDesk(clientId,nodecomponent,nodeObj,res) {
      let client = window.botStore.getClientByID(clientId);
        console.log("got result event",nodeObj, client.ClientLeft, client.ClientRight);
        let behaviour = {"Role":nodeObj.ArgJSON.Role,"Action":nodeObj.ArgJSON.Action,"Result":res,"Node":nodeObj,"Qualifier":""};

        let currentBehaviour = window.devStore.behaviours[client.ClientLeft+client.ClientRight];
        console.log("currentBehaviour : ", currentBehaviour);
      
         const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';
          let params = {
            ClientID : clientId,
            Type : "Result",
            Data : {"Node":nodeObj,"Behaviour":{"Role":behaviour.Role,"Action":behaviour.Action,"Result":behaviour.Role+':'+behaviour.Action+'/'+behaviour.Result,"Cycle":behaviour.Cycle,"Qualifier":behaviour.Qualifier},"FormData":{"Name":behaviour,"Results":behaviour},"Context":currentContext,"GraphTemplateID":nodeObj.GraphTemplateID,"GraphTemplate":nodeObj.GraphTemplateID}, 
          }
          console.log("Exec Result params",params);

          window.BotServices.ExecDesk(params, (err, result) => {
            if(result) {
                  console.log("===result Exec Result===",result);
                  closePopup();
                  if(result.State == 'Idle') {
                  }
              } else {
                  console.log("===result Exec Result Error===",err);
              }
          });
      }

    function manageMediaStreams12(event) {
        if (!Array.isArray(event.Streams)) return

        const action = (event.Action||'').toLowerCase()

        event.Streams.forEach(m => {
          if (!['video','screen'].includes(m.MediaType.toLowerCase())) return

          // try to find an existing stream item
          const idx = mediaItems.value.findIndex(
            x => x.clientId === m.ClientId && x.type === 'stream'
          )

          if (action === 'add') {
            if (idx === -1) {
              // push a new "live" stream item
              mediaItems.value.push({
                type:     'stream',
                clientId: m.ClientId,
                stream:   m.Stream,
                label:    `Client ${m.ClientId}`
              })
            } else {
              // update the existing one's .stream
              mediaItems.value[idx].stream = m.Stream
            }

          } else if (action === 'remove' && idx !== -1) {
            // remove from the array
            mediaItems.value.splice(idx, 1)
          }
        })
      }

    // --- Stream handling ---
    function manageMediaStreams1(event){
      const leftMenu=document.getElementById('leftMenuContainer')
      if(!leftMenu||!Array.isArray(event.Streams)) return
      event.Streams.forEach(m=>{
        if(!['Video','Screen'].includes(m.MediaType))return
        const cid=m.ClientId
        let v=document.getElementById(cid)
        if(event.Action==='Add'){
          if(!v){
            const wrap=document.createElement('div'); wrap.id='wrapper-'+cid
            const lbl=document.createElement('div'); lbl.innerText='Client '+cid
            lbl.style.textAlign='center';lbl.style.marginBottom='4px'
            lbl.style.display = 'none'
            v=document.createElement('video')
            v.id=cid; v.autoplay=true; v.playsInline=true
            v.onclick = () => focusItem(item)
            v.style.width='100%';v.style.marginBottom='8px'
            wrap.append(lbl,v); leftMenu.appendChild(wrap)
          }
          v.srcObject=m.Stream; v.play()
            .then(()=>updateVideoState({id:cid,state:'Play'}))
            .catch(console.error)
        } else if(event.Action==='Remove' && v){
          v.pause(); v.srcObject=null
          updateVideoState({id:cid,state:'Stop'})
          const wrap=document.getElementById('wrapper-'+cid)
          wrap && leftMenu.removeChild(wrap)
        }
      })
    }

    function updateVideoState(params) {

    }

    function getNodes(clientId) {
      console.log("Get Active Nodes Client",clientId);
      let clientObj = window.botStore.getClientByID(clientId);
      let currentContext = JSON.parse(clientObj.CurrentContext);
      const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';
      console.log("Get Active Nodes Client Obj :",clientObj);
      console.log("Get Active Nodes Current context :",currentContext);

      let params = {
        componentId : GRAPHSERVER,
        command : "GetNodesByRole",
        data : {ComponentID : currentContext.GrantRightID, Mode : 'Subject', Role : currentContext.GrantRightR },
        Type : 'BotApi'
      };

      console.log("Get Active Nodes params :",params);

      window.BotServices.callComponent(params, (err, result) => {
        if(result) {
          console.log("===Get Active Nodes===",result);
          manageDeskStreams(result,clientId);
        } else {
         console.log("No desk found");
        }
      });
    }

    const option1 = i => (dropdownOpen.value[i] = false);
    const option2 = i => (dropdownOpen.value[i] = false);

    return {
      mediaItems,
      focusedItem,
      overlayVisible,
      isMuted,
      isPlaying,
      isSwitchToVideo,
      isSwitchToScreen,
      isSwitchToFullScreen,
      dropdownOpen,
      startPstnFlag,
      startAudioFlag,
      allMuted,
      startVideoFlag,
      startScreenFlag,
      startWhiteboardFlag,
      startRecordingFlag,
      startChatFlag,
      startMeetingFlag,
      bottomMenuOpen,
      tiles,
      draggables,
      focusItem,
      toggleOverlay,
      getInitials,
      reloadAll,
      toggleMute,
      togglePlay,
      toggleFullscreenTile,
      fullscreenStates,
      toggleFullscreen,
      toggleDropdown,
      option1,
      option2,
      handleStartPstn,
      handleStopPstn,
      handleStartAudio,
      handleStopAudio,
      handleStartMute,
      handleStopMute,
      handleStartVideo,
      handleStopVideo,
      handleStartScreen,
      handleStopScreen,
      handleStartWhiteboard,
      handleStopWhiteboard,
      handleStartRecording,
      handleStopRecording,
      handleStartChat,
      handleStopChat,
      handleStopMeeting,
      handleRaiseHand,
      handleOrderStatus,
      handleOrderHistory,
      handleSwitchToWindow,
      handleAddParticipant,
      toggleBottomMenu,
      client,
      streamVideos,
      manageMediaStreams,
      executeDesk,
      itemKey,
      focusedItem,
      focusStream,
      switchToVideo,
      switchToScreen,
      deskItems,
      activeTab,
      showPopup,
      showUserPopup,
      popupUrl,
      openPopup,
      openUserPopup,
      closePopup,
      closeUserPopup,
      tilesContainer,
      showDnd,
      myTooltip,
      meetShortUrl,
      copyToClipboard,
      outFunc,
      participants,
      inviteParticipant,
      submitParticipant,
      doSomethingCool,
      panelItems,
      panelFrames
     /*ggleAudio,
      ggleVideo,
,
      disconnectCall,
      kickOut,
      handleFullscreenToggle,
      toggleMenu,
      handleZoomRangeChange,
      handlePanRangeChange,
      handleTiltRangeChange,
      closeModal
      */
    };
  }
};

</script>



<style scoped>
.media-wrapper { display: flex; flex-direction: column; height: 100vh; background: white; position: relative;    width: 96vw; }
.toggle-overlay-btn { position: absolute; top: 28px; z-index: 9999999999999; background: #ffffff; color: #0072C5; border: "3px solid #0072C5"; border-radius: 4px; padding: 1px 3px; cursor: pointer; transition: right 0.3s; }
.primary-view1 { flex: 1; position: relative; background: #eee; overflow: hidden; display: flex; justify-content: center; align-items: center; }
.primary-view {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 90vh;}
.primary-view iframe { width: 100%; height: 100%; object-fit: contain; border: none; }
.primary-view video {    position: absolute;
    top: 0;
    left: 0;
    width: 86%;
    height: 100%;
    object-fit: cover; }
.primary-view .avatar { width: 150px; height: 150px; border-radius: 50%; object-fit: cover; }
.video-grid-overlay { position: absolute; top: 0; right: 0; width: 200px; height: 100vh; background: rgba(255,255,255,0.95); display: flex; flex-direction: column; overflow-y: auto; padding: 5px; box-shadow: -2px 0 8px rgba(0,0,0,0.1); z-index: 999999; transition: width 0.3s ease, padding 0.3s ease; }
.video-grid-overlay.collapsed1 { width: 40px; padding: 5px; }
.video-grid-overlay.collapsed { width: 0px; padding: 0px; }
.video-tile { position: relative; width: 100%; height: 165px; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 8px; overflow: hidden; background: #fff; cursor: pointer; transition: transform 0.2s; }
.video-tile:hover { transform: scale(1.03); }
.video-tile iframe, .video-tile video, .tile-avatar { width: 100%; height: 100%; object-fit: cover; }
.tile-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer; z-index: 999999999999999999999999; }
.icon-bar { position: absolute; bottom: 0; left: 0; width: 100%; display: flex; justify-content: space-around; z-index: 4;background:white; }
.icon-bar button { background: none; border: none; color: black; font-size: 16px; cursor: pointer; }
.icon-bar button.active i { color: red; }
.dropdown { position: relative; }
.dropdown-menu { position: absolute; top: 24px; right: 0; background: #fff; border: 1px solid #ccc; border-radius: 4px; list-style: none; padding: 5px 0; margin: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.15); z-index: 5; }
.dropdown-menu li { padding: 5px 12px; cursor: pointer; }
.dropdown-menu li:hover { background: #f0f0f0; }
.initial-tile { display: flex; align-items: center; justify-content: center; width: 100%; height: 40px; margin-bottom: 5px; border: 1px solid #ccc; border-radius: 8px; background: #f7f7f7; color: #333; font-weight: bold; cursor: pointer; }
.global-controls { position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); background: #f0f0f0; padding: 8px 12px; border-radius: 6px; display: flex; gap: 10px; z-index: 3; }
.global-controls button { padding: 6px 12px; background: #333; color: #fff; border: none; border-radius: 4px; cursor: pointer; }
.bottom-bar { 
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
    background-color: white;
    border-top: 1px solid lightgray;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
    z-index: 100;
}
.control-button { background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    align-items: center;
    background-color: #fff;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
    color: #333;
    cursor: pointer;
    display: flex;
    height: 25px;
    justify-content: center;
    transition: all .3s ease;
    margin: 0 4px;
    width: 25px;
  }
.control-button.active i { color: red; }
.more-button { }
.bottom-dropdown-menu { position: absolute; bottom: 48px; background: #fff; border: 1px solid #ccc; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); }
.bottom-dropdown-menu .menu-item { display: flex; align-items: center; gap: 8px; padding: 6px 5px; background: none; border: none; cursor: pointer; width: 100%; text-align: left; }
.bottom-dropdown-menu .menu-item:hover { background: #f0f0f0;display: flex; align-items: center; gap: 8px; padding: 6px 5px; cursor: pointer; width: 100%; text-align: left; }
/* Make every <video> white behind the stream */
.tile-video,
.primary-video {
  background: white;
}

/* Hide native controls entirely */
.tile-video::-webkit-media-controls,
.primary-video::-webkit-media-controls {
  display: none !important;
}
.participant-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-button {
  background: none;
  border: none;
 /* border-radius: 50%;*/
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,.1);
}

.control-button.active i {
  color: red;
}

.more-button {
  /* optionally tweak */
}

.dropdown-menu1 {
  position: absolute;
  bottom: 48px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
  z-index: 10;
}

.dropdown-menu1 .menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.close-media-player {
  cursor: pointer;
  font-size: 1.2em;
  text-align: right;
  display: block;
}

.overlay-tabs {
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-top: 27px;
}
.overlay-tabs button {
  flex: 1;
  padding: 2px;
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay-tabs button.active {
  background: white;
  border-bottom: 2px solid #0072C5;
  color: #0072C5;
}
.overlay-tabs button i {
  margin-right: 4px;
}
.tiles-container {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}

.popup-btn {
  position: absolute;
  top: 8px;
  left: 8px;          /* ← now on the left */
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;
  z-index: 5;
}

.iframe-popup {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.8);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.iframe-popup iframe {
  width: 90%; height: 85%;
  background: #fff; border-radius: 6px; border: none;
}
.close-popup {
  position: absolute; top: 16px; right: 16px;
  background: #fff; border: none; border-radius: 50%;
  font-size: 18px; padding: 4px 8px; cursor: pointer;
}

/* in your scoped or global styles */
.iframe-backdrop {
  position: fixed;
  top:   0; left:  0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
.iframe-modal {
  position: relative;
  width:  36vw;
  height: 52vh;
  background: white;
  border-radius: 0px;
  overflow: hidden;
}
.iframe-close {
  position: absolute;
  top: -4px; right: 8px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 1;
  color: white;

}
.iframe-content {
  width: 100%;
  height: 100%;
  border: none;
}
.popup-btn {
  position: absolute;
  top:  10px;
  left: 10px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;
  z-index: 10;
}

.control-button,
.toggle-overlay-btn,
.overlay-tabs button {
  cursor: pointer;
}

.video-tile {
  position: relative;      /* ensure child absolute positioning is relative to this */
  overflow: hidden;        /* clip anything that overflows */
}

.tile-overlay {
  position: absolute;
  top: 0; left: 0;         /* fill the entire parent */
  width: 100%; height: 100%;
  cursor: pointer;         /* always show the pointer */
  z-index: 10;             /* above the video/iframe/content */
}

.tooltip-mc {
  position: relative;
  display: inline-block;
}

.control-button {
  /* your control-button styles */
}

.tooltiptext-mc {
  visibility: hidden;
  position: absolute;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  bottom: 125%; /* adjust as needed */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 10;
}

.dndtextnode {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}

.overlay-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* black at 50% opacity; adjust the alpha as needed */
  background-color: rgba(0, 0, 0, 0.5);
  /* ensure it sits above other content */
  z-index: 1000;
}

.overlay-text {
  font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-width: 0;
    border-color: #e2e8f0;
    height: 39px;
    color: #0072c5;
    display: flex;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto, Arial, Tahoma, Verdana, sans-serif !important;

}

/* Overlay icon bar on desktop (“desk”) view */
.desk-icon-bar {
  position: absolute;
    top: 42px;
    left: 0;
    width: 99%;
    display: flex;
    justify-content: left;
    background-color: white;
    padding: 13px 5px;
    z-index: 10;
}

/* Buttons inside */
.desk-icon-bar .control-button {
  margin: 0 6px;
  color: #fff;
  cursor: pointer;
}

/* Active state */
.desk-icon-bar .control-button.active i {
  color: red;
}

.entries-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #ddd;
}
.row {
  display: flex;
}
.cell {
  flex: 1;
  padding: 0px;
  border-bottom: 0px solid #eee;
  border-right: 0px solid #eee;
  text-align: center;
    font-size: 15px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-width: 0;
    border-color: #e2e8f0;
    height: 39px;
    color: #0072c5;
    display: flex;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto, Arial, Tahoma, Verdana, sans-serif !important;

}
.row:last-child .cell {
  border-bottom: none;
}
/* optional: remove right border on last cell */
.cell:last-child {
  border-right: none;
}
/* you can customize each row if needed */
.roles   { background: #f9f9f9; }
.actions { background: #fff; }
.results { background: #f9f9f9; }

.result-label {
  color: black;
  font-weight: bold;
}

.result-value {
  color: #0072C5;
  margin-left: 4px;
  display:flex;
  font-weight: 500;
  cursor:pointer;
}

.participant-row {
  display: flex;
  align-items: center;
  padding: 6px;
  border-bottom: 1px solid #eee;
}
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}
.status-dot.online { background: #4caf50; }
.status-dot.offline { background: #ccc; }
.participant-name {
  flex: 1;
}
.call-btn {
  background: none;
  border: none;
  color: #0072C5;
  cursor: pointer;
}

/* make the tabs small, square and center the icon */
.overlay-tabs {
  display: flex;
  gap: 8px;
}

.overlay-tabs button {
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.overlay-tabs button i {
  font-size: 20px;      /* icon size */
  color: #666;          /* inactive color */
  transition: color .2s;
}

.overlay-tabs button.active i {
  color: #0072C5;       /* highlight color */
}

.overlay-tabs button:hover i {
  color: #000;          /* hover color */
}

.raise-hand-container {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 9999;
}

.raise-hand-notification {
  display: inline-flex;
  align-items: center;
  background: rgba(0, 123, 255, 0.9);
  color: white;
  padding: 8px 12px;
  margin: 4px 0;
  border-radius: 20px;
  font-family: sans-serif;
  font-size: 14px;
  opacity: 0;
  animation: flyUpFade 3s ease-in-out forwards;
}

.raise-hand-notification .icon {
  margin-right: 8px;
  font-size: 18px;
}

@keyframes flyUpFade {
  0% {
    transform: translateX(-50%) translateY(100px) scale(0.8);
    opacity: 0;
  }
  10% { opacity: 1; }
  80% {
    transform: translateX(-50%) translateY(-200px) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(-300px) scale(1.2);
    opacity: 0;
  }
}

.my-fullscreen-component {
  position: absolute;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Always cover entire viewport */
#myFullScreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;      /* viewport width */
  height: 100vh;     /* viewport height */
  margin: 0;
  padding: 0;
  background: white;
  display: none;     /* you’ll flip this to “flex” in JS */
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

/* When the browser actually enters fullscreen, override any user-agent defaults */
#myFullScreen:-webkit-full-screen,
#myFullScreen:-moz-full-screen,
#myFullScreen:-ms-fullscreen,
#myFullScreen:fullscreen {
  width: 100%;
  height: 100%;
}

.desktop-panel {
  /* fill the entire viewport */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /* hide by default */
  display: none;

  /* center your content */
  display: flex;
  align-items: center;
  justify-content: center;

  background: white;
  z-index: 10000;
}

</style>
